import './footer.module.scss';
import './assets/footer.png';
